<template>
  <div class="tgbTagboardTimeline">
    <!-- Mirrors src/js/producer/timeline/multipost/timeline-multipost-template.html -->
    <div class="layer-tagboard" v-if="tagboard">
      <span
        v-if="avatar"
        class="tagboard-avatar"
        :style="{ 'background-image' : 'url(' + avatar + ')' }"
      />

      <div class="tagboard-title">
        {{tagboard.title}}
      </div>

      <div class="tagboard-description ml-1">
        {{tagboard.description}}
      </div>

      <dropdown position="left" class="more-actions ml-1">
        <template #trigger><button class="tb-btn tb-btn-text sm medium-em" title="More actions"><span class="fas fa-ellipsis-v"></span></button></template>
        <template #dropdown-body>
          <button class="dropdown-list-item" @click="removeTagboard"><span class="dropdown-list-item-label warning">Remove</span></button>
        </template>
      </dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineSocialTagboard',

  props: {
    tagboardId: {
      type: Number,
      required: true,
    }
  },

  computed: {
    tagboard() {
      return this.$store.state.tagboards.lookupTable[this.tagboardId];
    },

    avatar() {
      return this.tagboard.avatar_url ? this.tagboard.avatar_url : 'https://static.tagboard.com/producer/assets/img/logo-hash-t-white.svg';
    },
  },

  methods: {
    removeTagboard() {
      this.$emit('remove-tagboard', this.tagboardId);
    },
  },
};
</script>

<style lang="scss">
.tgbTagboardTimeline {
  width: 100%;

  // variables are mixed with css all over so can't include them without importing repeat code :X
  // So I'm just including them here
  $playlistBaseFontSize: 0.75rem;
  $playlistGeneralPadding: 0.25rem;
  $playlistOriginFlagSize: 1rem;
  $layerItemWidth: 10em;
  $layerItemHeight: 6em;
  $layerItemPaddingRight: 1.75rem;
  $layerPreviewHeight: 5em;
  $layerAvatarSize: 2rem;
  $layerTextPostWidth: 12em;
  $color-12dp: #333333;
  $color-active-green: #00D483;

  .tagboard-avatar {
    width: 2rem;
    height: 2rem;
    margin-right: 0.5rem;
    border-radius: 100%;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .layer-tagboard {
    display: flex;
    align-items: center;
    padding: $playlistGeneralPadding;
    background: $color-12dp;
    border-radius: 2px;
    border: 1px solid transparent;

    &.active {
      border-color: $color-active-green;
    }

    .tagboard-avatar {
      width: $layerAvatarSize;
      height: $layerAvatarSize;
      margin-right: 0.5rem;
      border-radius: 100%;
      background-position: 50% 50%;
      background-size: cover;
      background-repeat: no-repeat;
    }

    .tagboard-title,
    .tagboard-description {
      flex: 1;
      font-size: $playlistBaseFontSize;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
